import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Login } from './pages/Login';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { PropertiesList } from './pages/properties/PropertiesList';
import { PropertyForm } from './pages/properties/PropertyForm/index';
import { OwnersList } from './pages/owners/OwnersList';
import { CategoriesList } from './pages/categories/CategoriesList';
import { RatingsList } from './pages/ratings/RatingsList';
import { SettingsPage } from './pages/settings/SettingsPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.title = 'فيلا إسطنبول';
  }, [i18n.language]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Protected Dashboard Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/properties" replace />} />
            <Route path="properties" element={<PropertiesList />} />
            <Route path="properties/new" element={<PropertyForm />} />
            <Route path="properties/edit/:id" element={<PropertyForm />} />
            <Route path="owners" element={<OwnersList />} />
            <Route path="categories" element={<CategoriesList />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/properties" replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
